import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { catchError, of } from "rxjs";
import { TranslatePipe } from "@ngx-translate/core";
import { ProductCardComponent } from "@shared/components/organisms/product-card/product-card.component";
import { ProductCardSkeletonComponent } from "@shared/components/atoms/skeletons";
import { ProductsService } from "@shared/services/products.service";

@Component({
  selector: "app-category-products-preview",
  templateUrl: "./category-products-preview.component.html",
  styleUrl: "./category-products-preview.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ProductCardComponent, ProductCardSkeletonComponent],
})
export class CategoryProductsPreviewComponent {
  private readonly productsService = inject(ProductsService);

  readonly categoryId = input.required<string>();

  protected readonly productsResource = rxResource({
    params: () => this.categoryId(),
    stream: ({ params }) => this.productsService.getProductsByCategory(params, 3).pipe(catchError(() => of([]))),
    defaultValue: [],
  });
}
